import {
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Button,
    Box,
} from '@chakra-ui/react';

interface QuotesNotSubmittedProps {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const QuotesNotSubmitted = ({ onClick }: QuotesNotSubmittedProps) => {
    return (
        <Alert
            status="warning"
            borderRadius="md"
            border="1px solid"
            borderColor="orange.400"
            bg="orange.50"
        >
            <AlertIcon color="orange.500" />
            <Box flex="1">
                <AlertTitle color="gray.900" fontSize="md" fontWeight="bold">
                    Quotes Not Submitted!
                </AlertTitle>
                <AlertDescription color="gray.700" fontSize="sm">
                    Quotes have not been submitted for this order.{' '}
                    <Button
                        variant="link"
                        color="orange.500"
                        fontSize="sm"
                        fontWeight="normal"
                        textDecoration="none"
                        _hover={{ textDecoration: "none" }}
                        onClick={onClick}
                        p={0}
                        h="auto"
                        minW="auto"
                        verticalAlign="baseline"
                    >
                        View Order
                    </Button>
                </AlertDescription>
            </Box>
        </Alert>
    );
};

export default QuotesNotSubmitted; 